<div class="tw-flex tw-gap-1" [ngClass]="sale? 'tw-items-start': 'tw-items-center'">
    <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5 tw-px-2 tw-my-1">
        @if (sale) {
            <div class="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-1 tw-text-base tw-font-medium tw-tracking-tight"
                 [class.tw-cursor-pointer]="!disableActions">
                @switch (sale.order_type) {
                    @case ('delivery') {
                        <mat-icon class="tw-shrink-0" fontIcon="directions_bike"/>
                        <span class="tw-max-w-full tw-truncate" (click)="!disableActions && selectSaleActionEvent.emit()">
                            @if (!isTableNameOnTopBar || isMobile) {
                                {{ sale.channel | titlecase }} {{ sale.deliver_at | tilbyDate : formattedDateDeliverAt }}@if (sale.external_id) { - {{ getExternalId(sale.external_id) }} }
                            } @else {
                                {{ sale.name | titlecase }}
                            }
                        </span>
                        <ng-container *ngTemplateOutlet="deselectBtn"/>
                    }
                    @case ('take_away') {
                        @if (!isTableNameOnTopBar || isMobile) {
                            <mat-icon class="tw-shrink-0" fontIcon="local_mall"/>
                        }
                        <span class="tw-max-w-full tw-truncate" (click)="!disableActions && selectSaleActionEvent.emit()">
                            @if (!isTableNameOnTopBar || isMobile) {
                                {{ sale.deliver_at | tilbyDate : formattedDateDeliverAt }}@if (sale.external_id) { - {{ getExternalId(sale.external_id) }} }
                            } @else {
                                {{ sale.name | titlecase }}
                            }
                        </span>
                        <ng-container *ngTemplateOutlet="deselectBtn"/>
                    }
                    @default {
                        @if (!!sale.room_name) {
                            <span class="tw-max-w-full tw-truncate" (click)="!disableActions && selectSaleActionEvent.emit()">
                                {{ (!isTableNameOnTopBar || isMobile) ? (sale.room_name + ' - ' + sale.table_name) : (sale.name | titlecase) }}
                            </span>
                            <ng-container *ngTemplateOutlet="deselectBtn"/>
                        } @else {
                            <span class="tw-max-w-full tw-truncate" (click)="!disableActions && selectSaleActionEvent.emit()">{{ sale.name }}</span>
                            <ng-container *ngTemplateOutlet="saveBtn"/>
                        }
                        @if (sale.bill_lock) {
                            <mat-icon class="tw-shrink-0" fontIcon="lock"/>
                        }
                    }
                }
            </div>
            <div class="tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-3 tw-text-xs tw-text-[var(--sys-secondary-text)]">
                <span>{{ sale.open_at | tilbyDate : formattedDateCreatedAt }}</span>
                @if (sale.room_name || sale.order_type == 'delivery' || sale.order_type == 'take_away') {
                    @if (!isTableNameOnTopBar || isMobile) {
                        <span class="tw-font-medium">{{ sale.name || '' }}</span>
                    }
                }
                @if (documentData) {
                    <span class="tw-font-medium">{{ documentData }}</span>
                }
            </div>
        } @else {
            <div class="tw-cursor-pointer tw-py-2 tw-text-base tw-font-medium" (click)="selectSaleActionEvent.emit()">
                {{ 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.SELECT_SALE' | translate }}
            </div>
        }
    </div>
    <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-1 tw-p-1">
        @if (!disableActions) {
            @if (sale && showPreBill) {
                <button type="button"
                        class="tw-flex tw-h-10 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1 tw-rounded-xl tw-border-0 tw-bg-[var(--sys-card)] tw-px-3 tw-text-sm tw-font-medium tw-text-[var(--sys-text)] tw-shadow-[0_2px_6px_var(--sys-cashregister-shadow-color)] disabled:tw-cursor-default disabled:tw-opacity-40"
                        [class.tw-w-11]="!accessibility"
                        [disabled]="!isOrderPrinterPermitted"
                        tilbyGestures (click)="preBillActionEvent.emit()" (longPress)="openOrderPrinterSelectActionEvent.emit()">
                    <mat-icon fontIcon="list"/>
                    @if (accessibility) {
                        <span>{{ 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.PRE_BILL' | translate }}</span>
                    }
                </button>
            }
            @if (contextMenu.length) {
                <button type="button"
                        class="tw-flex tw-h-10 tw-w-9 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-[var(--sys-card)] tw-shadow-[0_2px_6px_var(--sys-cashregister-shadow-color)] tw-text-[var(--sys-text)]"
                        [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    @for (item of contextMenu; track $index) {
                        @if (item.isIt()) {
                            <button mat-menu-item (click)="item.click()" [disabled]="item.isDisable?.() || false">
                                @if (item.icon && item.iconType === undefined) {
                                    <mat-icon class="material-symbols-rounded">{{ item.icon() }}</mat-icon>
                                } @else if (item.icon && item.iconType === 'svg') {
                                    <mat-icon svgIcon="{{ item.icon() }}"></mat-icon>
                                }
                                <span>{{ item.name | translate }}</span>
                            </button>
                        }
                    }
                </mat-menu>
            }
        }
    </div>
</div>

@if (sale) {
    <div class="tw-flex tw-items-end tw-justify-between tw-gap-2 tw-px-2 tw-py-1">
        <button type="button"
                class="tw-flex tw-min-w-0 tw-max-w-[55%] tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded-xl tw-border-0 tw-bg-[var(--sys-card)] 
                tw-shadow-[0_2px_6px_var(--sys-cashregister-shadow-color)] tw-py-1 tw-pl-1 tw-pr-2 tw-text-sm tw-font-medium tw-tracking-tight tw-text-[var(--sys-text)]"
                tilbyGestures (click)="addCustomerActionEvent.emit()" (longPress)="removeCustomerAction()">
            @if (customerLabel) {
                <mat-icon class="tw-shrink-0 !tw-h-[22px] !tw-w-[22px] !tw-text-[22px] material-icons-outlined">account_circle</mat-icon>
            } @else {
                <mat-icon class="tw-shrink-0 !tw-h-[22px] !tw-w-[22px]" svgIcon="user-circle-plus"/>
            }
            <span class="tw-truncate">{{ customerLabel || 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.ADD_CUSTOMER' | translate }}</span>
        </button>
        <div class="tw-flex tw-min-w-0 tw-flex-col tw-items-end tw-gap-0.5 tw-font-medium tw-tabular-nums">
            @if (showSaleFinalAmount) {
                <span class="tw-whitespace-nowrap">{{ isHidePrices ? '***' : ((sale.final_amount || 0) | tilbyCurrency) }}</span>
            }
            @if (sale.covers) {
                <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-sm">
                    <span class="tw-flex tw-items-center tw-gap-1 tw-rounded-lg tw-bg-[var(--sys-card)] tw-px-1 tw-py-0.5">
                        <mat-icon class="!tw-h-4 !tw-w-4" svgIcon="users-three"/>
                        {{ sale.covers }}
                    </span>
                    @if (isHidePrices) {
                        <span class="tw-whitespace-nowrap">x ***</span>
                    } @else if (sale.covers > 1) {
                        <span class="tw-whitespace-nowrap">x {{ ((sale.final_amount || 0) / sale.covers) | tilbyCurrency }}</span>
                    }
                </div>
            }
        </div>
    </div>
}

<ng-template #deselectBtn>
    @if (!isPaymentsState && !deselectSalesFromMenuBar) {
        <button type="button" data-testid="deselect-sale"
                class="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded-lg tw-border-0 tw-bg-[var(--sys-card)] tw-p-0.5 tw-px-1.5 tw-text-sm tw-font-medium tw-text-[var(--sys-text)] tw-shadow-[0_2px_6px_var(--sys-cashregister-shadow-color)]"
                (click)="deselectSaleActionEvent.emit()">
            <mat-icon fontIcon="deselect"/>
            @if (accessibility) {
                <span>{{ 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.DESELECT' | translate }}</span>
            }
        </button>
    }
</ng-template>

<ng-template #saveBtn>
    @if (!isPaymentsState && !deselectSalesFromMenuBar) {
        <button type="button"
                class="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded-lg tw-border-0 tw-bg-[var(--sys-card)] tw-p-0.5 tw-px-1.5 tw-text-sm tw-font-medium tw-text-[var(--sys-text)] tw-shadow-[0_2px_6px_var(--sys-cashregister-shadow-color)]"
                (click)="saleChangeNameActionEvent.emit()">
            <mat-icon fontIcon="save"/>
            @if (accessibility) {
                <span>{{ 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.SAVE' | translate }}</span>
            }
        </button>
    }
</ng-template>
